/*
  Requires jquery.lettering.js
  Requires _flipping-text.scss

  Wrap all elements to flip in a "flipper-container" class.
  Wrap each element with "flipper" class.
*/

$(document).ready(function () {
  $flippers = $(".flipper");
  $flippers.lettering(); // breaks span into multile spans for letters

  //initialize flipper letters
  $flipperLetters = $(".flipper span");
  $flipperLetters.each(function () {
    $(this).attr('data-initial', $(this).text());
    $(this).css("opacity", 0);
  });
  $flippers.eq(0).find('span').css('opacity', 1);

  // keep all flipper heights equal to the tallest
  setFlipperHeights($flippers);
  $(window).on("resize", function () {
    setFlipperHeights($flippers);
  });

  // start flipper timeouts when page loads
  flipFlippersInSequence($flippers);

  // delay when flipper should activate based on (delay*curFlipperIndex)
  window.setInterval(function () {
    flipFlippersInSequence($flippers);
  }, 5000 * $flippers.length);

});

function flipFlippersInSequence($flippers) {

  // Loop through each flipper
  $flippers.each(function (curFlipperIndex, curFlipper) {

    // for reach flipper, set a delay for when its letters should animate so that they follow in sequence
    window.setTimeout(function () {
      var $curFlipper = $(curFlipper);
      var $curLetters = $curFlipper.find('span');
      var curLetterLastIndex = $($curLetters).length - 1;
      var $prevFlipper = curFlipperIndex == 0 ? $($flippers[$flippers.length - 1]) : $($flippers[curFlipperIndex - 1]);
      var $prevLetters = $prevFlipper.find('span');

      $curFlipper.addClass('active-flipper-text');
      $prevFlipper.removeClass('active-flipper-text');

      // delay when flipper letters should activate creating the animation
      $curLetters.each(function (curLetterIndex, curLetter) {
        setTimeout(function () {
          var $curLetter = $(curLetter);

          // first: hide previous letter at index
          $prevLetters.eq(curLetterIndex).css('opacity', 0);

          // second: swap and show cur letter at index
          var chars = ['$', '%', '#', '@', '&', '(', ')', '=', '*', '/', '{', '}'];
          var randomChar = chars[getRandomInt(0, chars.length - 1)];
          $curLetter.text(randomChar);
          $curLetter.css('opacity', 1);

          // third: swap back in actual letter after delay
          setTimeout(function () {
            $curLetter.text($curLetter.attr('data-initial'));
          }, 80);

          // OPTIONAL: fade out remaining letters before curLetters each loop breaks out and leaves them there
          if (curLetterIndex == ($curLetters.length - 1) && $curLetters.length < $prevLetters.length) {
            var $remainingLetters = $prevLetters.slice(curLetterIndex, $prevLetters.length);
            $remainingLetters.each(function (remainingLetterIndex, remainingLetter) {
              setTimeout(function () {
                $(remainingLetter).css('opacity', 0);
              }, 40 * remainingLetterIndex);
            });
          }

          // TODO - FIX THIS TERRIBLE THING
          if (curLetterIndex === curLetterLastIndex) {
            $($curLetters[curLetterLastIndex]).text($($curLetters[curLetterLastIndex]).attr('data-initial'));
          }

        }, 60 * curLetterIndex);
      });

    }, 5000 * curFlipperIndex);
  });
}

function setFlipperHeights($flippers) {
  var maxHeight = 0;
  $flippers.css("height", "auto");

  $flippers.each(function() {
    var height = $(this).outerHeight();
    if (height > maxHeight) maxHeight = height;
  });

  $flippers.css("height", maxHeight + 10);
  $flippers.closest("h1").css("padding-bottom", maxHeight + 10);
}

function getRandomInt(min, max) {
  return Math.floor(Math.random() * (max - min + 1)) + min;
}
